import { Component, OnInit, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { Order, OrderStateData } from '@us/web/shared/data-access';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { Router } from '@angular/router';
import { NgIf } from '@angular/common';
import { TuiTagModule } from '@taiga-ui/kit';
import { FormatCurrencyPipe } from '@us/web/shop/data-access';
import { TuiSvgModule } from '@taiga-ui/core';
import { RouteUtil, isFnBApp } from '@us/web/shared/utils';
import { FormatPipeModule, ParseIsoPipeModule } from 'ngx-date-fns';
import { ENVIRONMENT } from '@us/app-config';

@Component({
    selector: 'us-order-list-item',
    templateUrl: './order-list-item.component.html',
    styleUrls: ['./order-list-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        TuiTagModule,
        TranslocoModule,
        FormatCurrencyPipe,
        TuiSvgModule,
        FormatPipeModule,
        ParseIsoPipeModule
    ],
    standalone: true
})
export class OrderListItemComponent implements OnInit {
    @Input() order!: Order;

    orderItemsPreview = '';
    private readonly env = inject(ENVIRONMENT);
    readonly isFnBApp = isFnBApp(this.env);

    readonly OrderStateData = OrderStateData;

    constructor(private translocoService: TranslocoService, private router: Router) {}

    ngOnInit(): void {
        this.orderItemsPreview = this.getOrderItemsPreview();
    }

    private getOrderItemsPreview() {
        if (!this.order.items.length) {
            return '';
        }

        let str = this.order.items[0].product_name;

        if (this.order.items.length > 1) {
            str += ` ${this.translocoService.translate('and_other_products', { number: this.order.items.length - 1 })}`;
        }

        return str;
    }

    async onOrderClick() {
        await this.router.navigateByUrl(RouteUtil.getOrderRouteUrl(this.order.order_id));
    }
}
